// src/app/core/utils/firebase-error.ts
export class FirebaseAuthError extends Error {
  constructor(message: string, public code: string) {
    super(message);
    this.name = 'FirebaseAuthError';
    // Garante que a cadeia de protótipos esteja correta
    Object.setPrototypeOf(this, FirebaseAuthError.prototype);
  }
}
